import { useEffect, useState } from 'react';
import { useResizeObserver } from './useResizeObserver';

interface IProps {
    threshold?: number;
    initialState?: boolean;
}

/**
 * Hook that returns true when the viewport width exceeds a given threshold
 */
export const useExceedsBreakpoint = ({ threshold = 768, initialState = false }: IProps = {}): boolean => {
    const [exceeds, setExceeds] = useState(initialState);

    useEffect(() => {
        if (typeof window === 'undefined') {
            return;
        }

        const checkWidth = () => {
            setExceeds(window.innerWidth >= threshold);
        };
        checkWidth();
    }, [threshold]);

    useResizeObserver(typeof document !== 'undefined' ? document.body : null, () => {
        if (typeof window !== 'undefined') {
            setExceeds(window.innerWidth >= threshold);
        }
    });

    return exceeds;
};
